<template>
  <div>
    <el-select
      v-model="timeSelected"
      :size="size"
      placeholder="Tiempo"
      @change="OnTimeSelected"
      :disabled="isDisabled"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "TimeSelector",
  props: {
    timeToEdit: {
      type: Number,
      default: 0,
      required: false
    },
    size: {
      type: String,
      default: "mini",
      required: false
    },
    defaultTime: {
      type: Number,
      default: 0,
      required: false
    },
    isDisabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      timeSelected: 0,
      options: [
        { value: 0.5, label: "0.5" },
        { value: 1, label: "1" },
        { value: 1.5, label: "1.5" },
        { value: 2, label: "2" },
        { value: 2.5, label: "2.5" },
        { value: 3, label: "3" },
        { value: 3.5, label: "3.5" },
        { value: 4, label: "4" },
        { value: 4.5, label: "4.5" },
        { value: 5, label: "5" },
        { value: 5.5, label: "5.5" },
        { value: 6, label: "6" },
        { value: 6.5, label: "6.5" },
        { value: 7, label: "7" }
      ]
    };
  },
  created() {
    if (this.defaultTime > 0) {
      this.timeSelected = this.defaultTime;
    } else {
      this.timeSelected = this.timeToEdit;
    }
  },
  methods: {
    OnTimeSelected(event) {
      this.$emit("TimeSelected", event);
    }
  },
  watch: {
    timeToEdit(newValue) {
      if (this.defaultTime === 2) {
        this.timeSelected = 2;
      } else {
        this.timeSelected = newValue;
      }
    },
    defaultTime(oldValue, newValue) {
      this.timeSelected = oldValue || newValue;
    }
  }
};
</script>

<style></style>
